<template>
  <div class="panel-in-tab">
    <search-box class="search-box">
      <el-form :inline="true" size="mini" label-width="110px" :model="searchForm" :rules="rules" ref="searchForm">
        <el-form-item label="商品编码" prop="skuCode">
          <el-input v-model.trim="searchForm.skuCode" placeholder="请输入" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="商品名称" prop="goodsName">
          <el-input v-model.trim="searchForm.goodsName" placeholder="请输入" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="SPU编码" prop="spuCode">
          <el-input v-model.trim="searchForm.spuCode" placeholder="请输入" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="上市清单名称" prop="name">
          <el-input v-model.trim="searchForm.name" placeholder="请输入" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="上架标识" prop="upTypes">
          <el-select v-model="searchForm.upTypes" multiple collapse-tags placeholder="全部" clearable>
            <el-option label="需上架" value="1"></el-option>
            <el-option label="同以前" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="SKU推广名称" prop="skuName">
          <el-input v-model.trim="searchForm.skuName" placeholder="请输入" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="发货周期" prop="sendCycle">
          <el-select v-model="searchForm.sendCycle" placeholder="请选择" multiple collapse-tags filterable size="mini">
            <el-option v-for="item in sendCycleList" :key="item.confValue" :label="item.confName" :value="item.confValue"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="变更状态" prop="updateState">
          <el-select v-model="searchForm.updateState" clearable @change="onSearch">
            <el-option label="变更" value="1"></el-option>
            <el-option label="未变更" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="延期状态" prop="delayStatus">
          <el-select v-model="searchForm.delayStatus" clearable @change="onSearch">
            <el-option label="延期" value="0"></el-option>
            <el-option label="未延期" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="变更时间">
          <form-date-range :form="searchForm" startKey="updateDateStart" :usingTime="false" endKey="updateDateEnd" valueFormat="yyyy-MM-dd"> </form-date-range>
        </el-form-item>
        <el-form-item label="清单发布时间">
          <form-date-range :form="searchForm" startKey="realPublishDateStart" :usingTime="false" endKey="realPublishDateEnd" valueFormat="yyyy-MM-dd"> </form-date-range>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" size="mini" @click="onReset">重置</el-button>
      </template>
    </search-box>
    <el-row class="tabs-row">
      <el-col :span="10">
        <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="tabs">
          <template v-if="storeTabs.length">
            <el-tab-pane
              v-for="(tab, index) in storeTabs"
              :key="index"
              :label="tab.label + ' ' + tab.count"
              :name="tab.name"
              :disabled="loading && tab.name != activeTab"
            ></el-tab-pane>
          </template>
          <div v-else class="occupy"></div>
        </el-tabs>
      </el-col>
      <el-col :span="14" class="table-btn-area">
        <el-button type="primary" size="mini" @click="tableVisible = true">表格设置</el-button>
        <el-button type="primary" size="mini" @click="handleCannotBeListed(null)">批量暂缓上架</el-button>
        <el-button type="primary" size="mini" @click="handleNoListingRequired(null)">批量无需上架</el-button>
        <el-button type="primary" size="mini" @click="batchListing(null)">批量上架</el-button>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </el-col>
    </el-row>
    <table-panel ref="tablePanel">
      <vxe-table
        stripe
        border
        ref="tableRef"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        :cell-style="cellStyle"
        v-if="tableReload"
        v-loading="loading"
        empty-text="暂无待上架商品"
        @checkbox-change="handleSelectionChange"
        @checkbox-all="handleSelectionChange"
      >
        <vxe-column type="checkbox" width="39" fixed="left"></vxe-column>
        <vxe-column
          v-for="(item, index) in columnList"
          :key="index"
          :field="item.prop"
          :title="item.label"
          :min-width="item.width"
          :fixed="item.fixed"
          show-overflow
        >
          <template #default="{ row, column }">
            <template v-if="item.label === '图片'">
              <el-button v-if="row.imgUrlList && row.imgUrlList.length" size="mini" type="text" @click="viewImg(row.imgUrlList)">查看</el-button>
            </template>
            <template v-else-if="isShowTips(row, column)">
              <span>{{ row[item.prop] }}</span>
              <el-tooltip class="item" effect="dark" :content="getTips(row, column)" placement="top-start">
                <el-tag type="danger" effect="dark" size="mini" class="tagAlign">变</el-tag>
              </el-tooltip>
            </template>
            <template v-else-if="item.prop === 'name'">
              <span class="text-btn" @click="goListingList(row)">{{ row.name }}</span>
            </template>
            <span v-else>{{ row[item.prop] }}</span>
          </template>
        </vxe-column>
        <vxe-column title="操作" fixed="right" align="center" width="200">
          <template #default="{ row }">
            <el-button type="text" @click="batchListing(row)">上架</el-button>
            <el-button type="text" @click="handleNoListingRequired(row)" class="status-waiting" v-if="row.upType === '同以前'">无需上架</el-button>
            <el-button type="text" @click="handleCannotBeListed(row)" class="status-unable">暂缓上架</el-button>
          </template>
        </vxe-column>
      </vxe-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[100, 200, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <custom-table v-model="tableVisible" :tableDataSet="tableDataSet" v-if="tableVisible" @closeAddForm="closeAddForm" @confirm="confirm"></custom-table>
    <cannotBeListed :visible.sync="isShowCannotBeListed" v-if="isShowCannotBeListed" :rowData="rowData" :selectedRows="selectedRows" @getNewTab="getNewTab" />
    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close
      ><imgShow :imgList="imgList"></imgShow
    ></el-dialog>
  </div>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin';
import cannotBeListed from './components/cannotBeListed.vue';
import axios from '@/utils/axiosInstance';
import customPropsMixin from '../customProps.mixin';
import imgShow from '@/views/components/imgShow';
import moment from 'moment';
export default {
  name: 'PendingListing',
  mixins: [tableMixin, pagePathMixin, customPropsMixin],
  components: { cannotBeListed, imgShow },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 100,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      selectedRows: [],
      imgList: [],
      isShowCannotBeListed: false,
      imgFormVisible: false,
      rowData: {},
      searchForm: {
        skuCode: '',
        goodsName: '',
        spuCode: '',
        name: '',
        upTypes: [],
        skuName: '',
        sendCycle: [],
        updateState: '',
        delayStatus: '',
        updateDateStart: '',
        updateDateEnd: '',
        realPublishDateStart: '',
        realPublishDateEnd: '',
      },
      activeTab: undefined,
      storeTabs: [],
      sendCycleList: [],
      reportName: 'waitUp',
      spanArr: [],
      spanIndex: 0,
    };
  },
  computed: {},
  mounted() {
    let query = this.$route.query;
    this.$set(this.searchForm, 'delayStatus', query.delayStatus || '');
    this.$set(this.searchForm, 'updateState', query.updateState || '');
    this.getSendCycleList();
  },
  watch: {
    $route: {
      handler(val, olv) {
        if (olv.path == '/dataBoard/agencyWorkbench') {
          this.$set(this.searchForm, 'delayStatus', val.query.delayStatus || '');
          this.$set(this.searchForm, 'updateState', val.query.updateState || '');
          this.onSearch();
        }
      },
    },
  },
  methods: {
    getStroeTab() {
      this.loading = true;
      const data = new FormData();
      data.append('state', 0);
      this.$q.newProduct.statisticsByStore({ data: data }).then((res) => {
        this.storeTabs = res.data.map((v) => {
          return {
            label: v.storeName,
            name: v.storeCode,
            count: v.qty,
          };
        });
        if (!this.storeTabs || !this.storeTabs.length) {
          this.loading = false;
          this.tableData.total = 0;
          this.tableData.list = [];
          return;
        }
        let tabs = this.storeTabs.map((v) => v.name);
        this.activeTab = this.activeTab == 0 || !tabs.includes(this.activeTab) ? this.storeTabs[0].name : this.activeTab;
        this.$nextTick((_) => {
          this.onSearch();
        });
      });
    },

    handleTabClick() {
      this.onSearch();
    },

    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },

    async init() {
      this.loading = true;
      let { skuCode, spuCode } = this.searchForm;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          ...this.searchForm,
          storeCode: this.activeTab,
          state: 0,
          skuCode: skuCode ? skuCode.split(' ') : [],
          spuCode: spuCode ? spuCode.split(' ') : [],
        },
      };
      this.searchFormData = data;
      this.$q.newProduct
        .productListUpPage({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.computeSpanData(res.data.list);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },

    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    onReset() {
      this.searchForm = {
        productCode: '',
        spuCode: '',
        name: '',
        listingStatus: '',
        delayStatus: '',
        realPublishDateStart: '',
        realPublishDateEnd: '',
      };
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    handleSelectionChange(selection) {
      this.selectedRows = selection.records || selection;
    },

    goListingList(row) {
      this.$router.push({ path: '/newProduct/listingList', query: { name: row.name } });
    },

    // 查看图片
    viewImg(imgList) {
      this.imgFormVisible = true;
      let pathList = imgList ? imgList.map((v) => v.path) : [];
      this.imgList = pathList;
    },

    // 批量上架
    batchListing(row) {
      if (this.selectedRows.length === 0 && !row) {
        this.$message.warning('请先选择商品');
        return;
      }
      const stroeName = this.storeTabs.find((item) => item.name === this.activeTab).label;
      this.$confirm(`确认该商品在"${stroeName}"已上架吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          // 调用批量上架接口
          const ids = row ? [row.id] : this.selectedRows.map((item) => item.id);
          this.$q.newProduct.productListUpNew({ data: ids }).then((res) => {
            if (res.success) {
              this.$message.success('批量上架成功');
              this.getNewTab();
            }
          });
        })
        .catch(() => {});
    },

    // 无需上架
    handleNoListingRequired(row) {
      if (this.selectedRows.length === 0 && !row) {
        this.$message.warning('请先选择商品');
        return;
      }
      const stroeName = this.storeTabs.find((item) => item.name === this.activeTab).label;
      this.$confirm(`确认该商品在"${stroeName}"无需上架吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const ids = row ? [row.id] : this.selectedRows.map((item) => item.id);
          this.$q.newProduct.productListUpNoNeedUp({ data: ids }).then((res) => {
            if (res.success) {
              this.$message.success('无需上架成功');
              this.getNewTab();
            }
          });
        })
        .catch(() => {});
    },

    getNewTab() {
      this.$emit('getNumber');
      this.$store.dispatch('menu/getMenusNum', {}, { root: true });
      this.getStroeTab();
    },

    // 暂缓上架
    handleCannotBeListed(row) {
      if (this.selectedRows.length === 0 && !row) {
        this.$message.warning('请先选择商品');
        return;
      }
      this.rowData = row;
      this.isShowCannotBeListed = true;
    },

    isShowTips(row, column) {
      let propList = row.fieldBOS ? row.fieldBOS.map((v) => v.field) : [];
      return propList.includes(column.property);
    },
    getTips(row, column) {
      if (!row.fieldBOS) return;
      let propData = row.fieldBOS.find((v) => v.field == column.property);
      return `变更前：${propData.oldVal},变更后：${propData.newVal}`;
    },

    getSendCycleList() {
      let data = {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        hasCount: 'N',
      };
      data.reportCode = 'sendCycle';
      axios.post(`/ec-pc-api/custom/reports/data/sendCycle`, data).then((res) => {
        if (res.code == 200) {
          this.sendCycleList = res.data.list.filter((v) => v.categoryCode == 'sendCycle');
        }
      });
    },

    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      this.searchFormData.pageSize = 9999999;
      this.$q.newProduct
        .productListUpExport({
          data: this.searchFormData,
          options: { responseType: 'blob' },
        })
        .then((res) => {
          let fileName = '待上架' + moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
          this.blobDownload(res, `${fileName}.xlsx`);
          loading.close();
        });
    },
    cellStyle({ row, column }) {
      if (row.fieldBOS && row.fieldBOS.length) {
        return {
          color: '#F56C6C',
        };
      }
      return {};
    },
  },
};
</script>

<style lang="stylus" scoped>
.panel-in-tab {
  >>> .search-outer>div {
    padding: 0;
  }
}

.search-box {
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input {
    width: 240px !important;
  }
}

>>> .date-range .single-date {
  width: 110px !important;
}

>>> .form-number-input .el-input-number {
  width: 105px !important;
}

>>> .form-number-input .el-input-number .el-input {
  width: 105px !important;
}

.tabs-row {
  margin-bottom: 5px;
}

.tabs {
  >>> .el-tabs__header {
    margin: 0 !important;
  }
}

.occupy {
  width: 200px;
  height: 20px
}

.table-btn-area {
  text-align: right;
  line-height: 40px;
}
.tagAlign {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
}
.text-btn {
  cursor: pointer;
  color: #0bb78e
}
.status-waiting {
  color: #409EFF;
}

.status-unable {
  color: #F56C6C;
}

>>> .el-select__tags-text {
  display: inline-block;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
>>> .el-tag__close.el-icon-close {
  top: 0px;
  right: -4px
}
</style>
